export default "__VITE_ASSET__MA56is5y__"